<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, FreeMode } from 'swiper/modules'
import RemoteImage from '@/components/general/BaseRemoteImage.vue'

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const categoriesStore = useCategoriesStore()
const { getEventCategories } = storeToRefs(categoriesStore)
</script>

<template>
  <div class="event-categories bg-white zindex-10 relative flex flex-row shadow items-center ">
    <button
      id="spec-category-prev"
      class="btn-spec-category zindex-11 border-0 text-primary bg-primary-200 p-3 flex justify-center items-center rounded-pill my-1 ml-1"
    >
      <i class="mi-chevron-l" />
    </button>
    <Swiper
      :slides-per-view="'auto'"
      :space-between="0"
      :free-mode="true"
      :grab-cursor="true"
      :threshold="10"
      :loop="true"
      :modules="[FreeMode, Navigation]"
      :navigation="{
        nextEl: '#spec-category-next',
        prevEl: '#spec-category-prev',
      }"
      :breakpoints="{
        0: {
          loop: true,
        },
        1268: {
          loop: false,
          slidesPerGroup: 4
        }
      }"
      class="text-primary m-0 px-2 w-100"
    >
      <SwiperSlide
        v-for="(item, index) in getEventCategories"
        :key="index"
        class="text-sm font-weight-500 text-nowrap my-0 ml-0 w-auto py-3 px-3"
      >
        <RouterLink
          :to="{ name: item.name, params: { permalink: item.permalink } }"
          class="underline-hover flex items-center"
        >
          <RemoteImage
            :src="`https://img.mix.it/general_assets/categories/${item.image}`"
            :alt="item.title"
            img-class="event-img mr-1"
            bird-class="event-img mr-1"
          />
          {{ item.title }}
        </RouterLink>
      </SwiperSlide>
    </Swiper>
    <button
      id="spec-category-next"
      class="btn-spec-category zindex-11 border-0 text-primary bg-primary-200 p-3 flex justify-center items-center rounded-pill my-1 mr-1"
    >
      <i class="mi-chevron-r" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.event-categories {
  max-height: 55px;
}
.event-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.btn-spec-category {
  &.swiper-button-disabled {
    display: none !important;
  }
}
</style>